import React from "react";
import { useRef } from "react";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Join.css";

const Join = () => {
  const [] = useState();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_vsh50hk",
        "template_zhhqbkx",
        form.current,
        "6bYNFqxN5FT-zTbAj"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">Ready to</span>
          <span> Level up</span>
        </div>
        <div>
          <span>your body</span>
          <span className="stroke-text"> with us</span>
        </div>
      </div>
      <div className="right-j">
        <form
          action=""
          className="email-container"
          ref={form}
          onSubmit={sendEmail}
        >
          <input
            type="email"
            name="user_email"
            placeholder="Enter your email address"
          />
          <button className="btn btn-join" type="submit">
            Join Now
          </button>
        </form>
      </div>
    </div>
  );
};

export default Join;
